/* USERS TYPE */
export const Administrator = 1;
export const Reseller = 2;
export const Subscriber = 3;
/* USERS TYPE */
